<script setup lang="ts">
import { onMounted } from 'vue'

const CLIENT_KEY = 'E93wTC6HclocljPELpY1M-H5OpfLSC909tSB7nDO4uU='

// Resolve the widget icon color from the design-system token (--color-widget in main.css),
// falling back to the literal hex. The external loader needs a concrete hex string attribute.
function themeColor(): string {
  const v = getComputedStyle(document.documentElement).getPropertyValue('--color-widget').trim()
  return v || '#004AAD'
}

function widgetApi(): Promise<{ sendConfig: (cfg: object) => void }> {
  return new Promise((resolve) => {
    let timeoutId: ReturnType<typeof setTimeout>
    const getApi = () => {
      timeoutId = setTimeout(getApi, 1000)
      window.dispatchEvent(new Event('getWidgetApi'))
    }
    const onWidgetApi = (e: Event) => {
      clearTimeout(timeoutId)
      resolve((e as CustomEvent).detail)
    }
    window.addEventListener('widgetApi', onWidgetApi, { once: true })
    getApi()
  })
}

onMounted(() => {
  const customTheme = themeColor()
  const s = document.createElement('script')
  s.async = true
  s.src = 'https://maira.gigalogy.com/loader'
  s.setAttribute('data-greeting', 'Hi, I am Maira. How can I help you today?')
  s.setAttribute('data-client-key', CLIENT_KEY)
  s.setAttribute('data-chat-header', 'Ask Maira!')
  s.setAttribute('data-icon-color', customTheme)
  s.setAttribute('data-prefix', window.location.hostname)
  document.head.appendChild(s)

  widgetApi().then((api) => {
    api.sendConfig({ theme: customTheme, colorSet: {} })
  })
})
</script>

<template></template>
